import React from 'react'
import styled from 'styled-components'
import { Text } from 'components/Typography'
import {
  BORDER_WIDTH,
  COLOR_INTENT,
  FONT_SIZE,
  FONT_WEIGHT,
  LINE_HEIGHT,
  RADIUS,
  SPACE,
} from 'Theme'

const Wrapper = styled(Text)`
  white-space: nowrap;
  width: max-content;
  padding: ${SPACE.PX_2} ${SPACE.PX_10};
  height: max-content;
  border-radius: ${RADIUS.PX_6};
  background-color: ${({ variant }) => COLOR_INTENT.BADGE[variant].BACKGROUND};
  color: ${({ variant }) => COLOR_INTENT.BADGE[variant].TEXT};
  border: ${({ variant }) =>
    COLOR_INTENT.BADGE[variant].BORDER
      ? `${BORDER_WIDTH.PX_1} solid ${COLOR_INTENT.BADGE[variant].BORDER}`
      : 'none'};
`

export const BADGE_VARIANTS = {
  GREEN: 'GREEN',
  ORANGE: 'ORANGE',
  RED: 'RED',
  GRAY: 'GRAY',
  BROWN: 'BROWN',
  BLUE: 'BLUE',
  WHITE: 'WHITE',
} as const

interface BadgeProps {
  variant?: (typeof BADGE_VARIANTS)[keyof typeof BADGE_VARIANTS]
}

export const Badge: React.FC<React.PWC<BadgeProps>> = ({
  variant = BADGE_VARIANTS.GRAY,
  children,
}) => (
  <Wrapper
    variant={variant}
    fontWeight={FONT_WEIGHT.MEDIUM}
    fontSize={FONT_SIZE.PX_12}
    lineHeight={LINE_HEIGHT.M}
  >
    {children}
  </Wrapper>
)
